import type { RouteRecordRaw } from 'vue-router'
import { PageTypes } from '@core/constants/pages'

const HomePage = async () => import('./home.vue')

const routes: RouteRecordRaw[] = [
  {
    name: 'homepage',
    path: '/',
    meta: { pageType: PageTypes.HOME, lang: 'en' },
    component: HomePage,
  },
  {
    name: 'homepage-lang',
    path: `/${LANG_PARAM}`,
    meta: { pageType: PageTypes.HOME },
    component: HomePage,
  },
  {
    name: 'homepage-lang-full',
    path: `/${LANG_PARAM}/homepage`,
    meta: { pageType: PageTypes.HOME },
    component: HomePage,
  },
]

export default routes
